<div class="container-wrapper" style={`${$$props.style || ''}`}>
    <div class="container-inner" style={`${$$props.innerStyle || ''}`}>
        <slot />
    </div>
    <slot name="background" />
</div>

<style lang="scss">
    .container-wrapper {
        overflow-x: hidden;
        position: relative;
        width: 100%;
    }

    .container-inner {
        position: relative;
        margin: 0 auto;
        max-width: calc(1280px - (31px * 2));
        z-index: 1;
    }

    @media (max-width: 1279px) {
        .container-inner {
            max-width: calc(100% - (22px * 2));
        }
    }

    @media (max-width: 420px) {
        .container-inner {
            max-width: calc(100% - (20px * 2));
        }
    }
</style>